import i18n from 'i18next'

import { Backbone, BackboneSelectOption } from '../../../types/backbone'

const backboneDescriptionI18nKeys = {
  dino_vitb8_runtime: i18n.t(
    'The best performances at the cost of a reduced inference speed.'
  ),
  dino_vits8_runtime: i18n.t('Good performances and average inference speed.'),
  levit_128s_runtime: i18n.t(
    'Average performances but faster inference speed.'
  ),
  vit_tiny16_runtime: i18n.t(
    'Pick this model if speed is the only thing that matters to you.'
  ),
  mobilenet_v2_unet: i18n.t(
    'Model for precise segmentation and lower inference time. This model needs more data to be trained.'
  ),
  dino_vitb8_segmentationattention: i18n.t(
    'Big model for macro defects segmentation with few data. Higher inference time.'
  ),
  resnet18: i18n.t(
    'Model for fast anomaly detection, but with lower precision.'
  ),
  wide_resnet50_2: i18n.t(
    'Model for precise anomaly detection, but with higher inference time.'
  ),
  logical_anomaly: i18n.t(
    'Best used to find logical anomalies (e.g. color differences, object swaps) or with tiny position shifts in good samples.'
  ),
}

export const backboneToOption = () => (
  backbone: Backbone
): BackboneSelectOption => ({
  name: backbone.name,
  id: backbone.id,
  code: backbone.code,
  value: backbone.code,
  label:
    backbone.name +
    (backbone.isDemo ? ' [🚧 demo - not available for download ]' : ''),
  description:
    backbone.code in backboneDescriptionI18nKeys
      ? backboneDescriptionI18nKeys[
          backbone.code as keyof typeof backboneDescriptionI18nKeys
        ]
      : backbone.description,
  isDemo: backbone.isDemo,
  isDefault: false,
  metadata: backbone.metadata,
})
